<eff-expansion-panel
    [contentTemplate]="content"
    [title]="'controls.effSourceDocumentInfoBox.panelTitle' | transloco"
    class="eff-details-panel"
    [panelOpenState]="panelOpenState"
    data-uiid="new-eff-upload-source-document-source-upload-instructions-info-box"
>
    <ng-template #content>
        <div class="rows-container">
            <div
                class="regular-text multiple-whitespaces"
                [innerHTML]="effectivenessModel.sourceDocumentUploadInstructions"
            ></div>
            @if (
                stepPermissions?.canViewSourceDocuments && !effectivenessModel.useControlExecution
            ) {
                <div class="source-documents-list">
                    @if (sourceDocumentModel && sourceDocumentModel.documents?.length > 0) {
                        <documents-list
                            [canAdd]="false"
                            [canEdit]="false"
                            [canDelete]="false"
                            [documents]="sourceDocumentModel.documents"
                        ></documents-list>
                    } @else {
                        <div class="header no-documents">{{ 'controls.effSourceDocumentInfoBox.noSourceDocuments' | transloco }}</div>
                    }
                </div>
            }
            @if (isNonOccurrenceTestPlan && effectivenessModel.useControlExecution) {
                <div class="header no-documents">
                    {{ 'controls.effSourceDocumentInfoBox.noControlExecutions' | transloco }}</div>
            }

            @if (!isNonOccurrenceTestPlan) {
                <div class="rows-container">
                    @if (
                        stepPermissions?.canViewSourceDocuments &&
                        effectivenessModel.useControlExecution
                    ) {
                        <div class="row-container popup-hover" (click)="openPopup()">
                            <div class="view-sources-text">{{ 'controls.effSourceDocumentInfoBox.viewTasks' | transloco }}</div>
                            <eff-icon
                                icon="north_east_outlined"
                                size="sixteen-size ocean-blue lh-24"
                            >
                            </eff-icon>
                        </div>
                    }
                    <div class="bold-text header">{{ 'controls.effSourceDocumentInfoBox.sampling' | transloco }}</div>
                    @if (effectivenessModel.samplePopulation) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'controls.effSourceDocumentInfoBox.population' | transloco }}</div>
                            <div class="regular-text">
                                {{ effectivenessModel.samplePopulation }}
                            </div>
                        </div>
                    }
                    @if (effectivenessModel.numberOfTestSamples) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'controls.effSourceDocumentInfoBox.sampleSize' | transloco }}</div>
                            <div class="regular-text">
                                {{ effectivenessModel.numberOfTestSamples }}
                            </div>
                        </div>
                    }
                    @if (effectivenessModel.sampleTypeDescription) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'controls.effSourceDocumentInfoBox.sampleType' | transloco }}</div>
                            <div class="regular-text">
                                {{ effectivenessModel.sampleTypeDescription }}
                            </div>
                        </div>
                    }

                    @if (isSpreadSheet()) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'controls.effSourceDocumentInfoBox.columnId' | transloco }}</div>
                            <div class="regular-text">{{ columnId }}</div>
                        </div>

                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'controls.effSourceDocumentInfoBox.rowsToSkip' | transloco }}</div>
                            <div class="regular-text">{{ rowsToSkip }}</div>
                        </div>
                    }

                    @if (
                        effectivenessModel.sampleGenerationType == sampleGenerationType.automatic &&
                        effectivenessModel.seedNumber
                    ) {
                        <div class="row-container">
                            <div class="bold-text row-label">{{ 'controls.effSourceDocumentInfoBox.seedNumber' | transloco }}</div>
                            <div class="regular-text">{{ effectivenessModel.seedNumber }}</div>
                        </div>
                    }

                    @if (effectivenessModel.sampleGenerationType == sampleGenerationType.manual) {
                        <div class="bold-text row-label">{{ 'controls.effSourceDocumentInfoBox.reasonManualSampling' | transloco }}</div>
                        <div class="regular-text">
                            {{ effectivenessModel.sampleGenerationReason }}
                        </div>
                    }
                    @if (effectivenessModel.useControlExecution) {
                        <div
                            class="row-container download-sampled-population"
                            data-uiid="new-eff-upload-source-document-source-upload-instructions-info-box-download-sampled-population-button"
                            (click)="downloadSampledPopulation()"
                        >
                            <eff-icon
                                class="action-icon"
                                icon="cloud_download_outlined"
                                [size]="''"
                            ></eff-icon>
                            <div class="download-sampled-population-text">
                                {{ 'controls.effSourceDocumentInfoBox.downloadSampledPopulation' | transloco }}
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </ng-template>
</eff-expansion-panel>
